// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyFolders-modulecontainerDcv","icon":"EmptyFolders-moduleicon3sO","title":"EmptyFolders-moduletitle2uq","text":"EmptyFolders-moduletext2OW"};